import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {GridService} from "../../../services/grid.service";
import {HttpService} from "../../../services/http.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-ai-tree-product',
  templateUrl: './ai-tree-product.component.html',
  styleUrls: ['./ai-tree-product.component.scss']
})
export class AiTreeProductComponent implements ICellRendererAngularComp {
  private params: any;
  public value: any;

  constructor(
    private gridService: GridService,
    private httpService: HttpService
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.value = params.data?.products;
  }

  onClick(val: any): void {
    console.log('onClick123', val);
    // this.httpService.post(environment.API_PATH + '/ai/getProductDetail', {
    //   product_id: val
    // }).subscribe(res => {
    //   this.gridService.aiTreeSelectProject.next(res);
    // });
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  protected readonly onclick = onclick;
}
